import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import {
  ACTION_TYPES,
  getAsyncActionTypePending,
  getAsyncActionTypeReject,
  getAsyncActionTypeFulfiled
} from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../../constants/status.constant';

/**
 * Calendar reducer - stores ONLY raw data.
 * All filtering, sorting, and transformation logic moved to selectors.
 */
const initialState = () => ({
  professionals: [],
  resume: {},
  search: '',
  fetchStatus: STATUS.IDLE,
  fetchError: null,
  searchStatus: STATUS.IDLE,
  searchError: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case getAsyncActionTypePending(ACTION_TYPES.FETCH_CALENDAR): {
      return {
        ...state,
        fetchStatus: STATUS.LOADING,
        fetchError: null
      };
    }
    case getAsyncActionTypeReject(ACTION_TYPES.FETCH_CALENDAR): {
      return {
        ...state,
        fetchStatus: STATUS.FAILED,
        fetchError: action.error || new Error('Fetch failed')
      };
    }
    case getAsyncActionTypeFulfiled(ACTION_TYPES.FETCH_CALENDAR): {
      const payload = action.payload || {};
      const professionals = payload.professionalsCalendar
        ? Object.values(payload.professionalsCalendar)
        : payload.professionals || [];

      return {
        ...state,
        fetchStatus: STATUS.SUCCEEDED,
        fetchError: null,
        professionals: [...state.professionals, ...professionals],
        resume: payload.resume || {}
      };
    }
    case getAsyncActionTypePending(ACTION_TYPES.FETCH_CALENDAR_SEARCH): {
      return {
        ...state,
        searchStatus: STATUS.LOADING,
        searchError: null
      };
    }
    case getAsyncActionTypeReject(ACTION_TYPES.FETCH_CALENDAR_SEARCH): {
      return {
        ...state,
        searchStatus: STATUS.FAILED,
        searchError: action.error || new Error('Search failed')
      };
    }
    case getAsyncActionTypeFulfiled(ACTION_TYPES.FETCH_CALENDAR_SEARCH): {
      const { data, searchTerm } = action.payload;
      const professionals = data.professionalsCalendar
        ? Object.values(data.professionalsCalendar)
        : data.professionals || [];

      return {
        ...state,
        searchStatus: STATUS.SUCCEEDED,
        searchError: null,
        search: searchTerm || '',
        professionals,
        resume: data.resume || {}
      };
    }
    case types.ACTION_TYPES.RESET_CALENDAR: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
